import { defineMessages } from './define'

/* The first patient screens translated: home, queue ticket, bookings and the
 * WhatsApp tickets. Keys here predate the per-area modules, so they carry no
 * prefix. */

export default defineMessages({
  en: {
    hi: 'Hi, {name}',
    goodMorning: 'Good morning',
    goodAfternoon: 'Good afternoon',
    goodEvening: 'Good evening',
    visits: 'Visits',
    lastSeen: 'Last seen',
    upcoming: 'Upcoming',
    careEyebrow: 'Care when you need it',
    findDoctorTitle: 'Find a doctor for your next visit',
    findDoctorBody: 'Browse specialties and available consultation times.',
    findDoctor: 'Find a doctor',
    loadingSummary: 'Loading your health summary…',
    yourAppointments: 'Your Appointments',
    yourDetails: 'Your Details',
    patientCode: 'Patient code',
    mobile: 'Mobile',
    bloodGroup: 'Blood group',
    allergies: 'Allergies',
    chronic: 'Chronic',
    medication: 'Medication',
    doctors: 'Doctors',
    visitHistory: 'Visit History',
    noDiagnosis: 'No diagnosis recorded',
    visit: 'Visit',
    // queue ticket
    yourTurn: 'Your turn today',
    serial: 'Serial',
    nowServing: 'Now serving',
    aheadOfYou: '{n} ahead of you',
    youAreNext: 'You are next',
    beingSeen: 'The doctor is seeing you now',
    seenDone: 'Your consultation is done',
    refreshesItself: 'Updates by itself every 30 seconds.',
    // bookings
    myAppointments: 'My appointments',
    myLabTests: 'My lab tests',
    past: 'Past',
    cancelled: 'Cancelled',
    cancel: 'Cancel',
    move: 'Move',
    keep: 'Keep it',
    cancelTitle: 'Cancel this booking?',
    cancelReason: 'Reason',
    cancelReasonPh: 'Something came up…',
    changeWindow: 'You can change a booking here up to 2 hours before. After that, please call the clinic.',
    noLabTests: 'No lab tests booked',
    bookLabTest: 'Book a lab test',
    bookThisTest: 'Book this test',
    shareTicket: 'Share ticket',
    // tickets
    tApptConfirmed: 'appointment confirmed',
    tApptMoved: 'appointment moved',
    tLabBooked: 'lab test booked',
    tBooking: 'Booking',
    tPatient: 'Patient',
    tDoctor: 'Doctor',
    tTest: 'Test',
    tDate: 'Date',
    tTime: 'Time',
    tWhen: 'When',
    tPaid: 'Paid · receipt {ref}',
    tPaidPlain: 'Paid',
    tFeeDue: 'Fee: {amount} — pay at the clinic',
    tNothingDue: 'Fee: nothing due',
    tPreparation: 'Preparation',
    tClinicPhone: 'Clinic phone',
    tArrive: 'Please arrive 10 minutes early and bring this ticket.',
    tSerial: 'Serial number',
    tAmountPaid: 'Amount: {amount} — paid',
    tAmountPaidReceipt: 'Amount: {amount} — paid (receipt {ref})',
    tAddress: 'Address',
    tLabArrive: 'Please arrive 10 minutes before your time and show this message at the lab counter.',
    tReceiptTitle: 'payment receipt',
    tReceiptNo: 'Receipt',
    tFee: 'Fee',
    tDiscount: 'Discount',
    tPaidBy: 'Paid: {amount} by {mode}',
    tBalanceDue: 'Balance due: {amount}',
    tReference: 'Reference',
    tKeepReceipt: 'Thank you. Keep this message as your receipt.',
  },
  hi: {
    hi: 'नमस्ते, {name}',
    goodMorning: 'सुप्रभात',
    goodAfternoon: 'नमस्कार',
    goodEvening: 'शुभ संध्या',
    visits: 'विज़िट',
    lastSeen: 'पिछली बार',
    upcoming: 'आगामी',
    careEyebrow: 'जब ज़रूरत हो, तब देखभाल',
    findDoctorTitle: 'अपनी अगली विज़िट के लिए डॉक्टर चुनें',
    findDoctorBody: 'विशेषज्ञता और उपलब्ध परामर्श समय देखें।',
    findDoctor: 'डॉक्टर खोजें',
    loadingSummary: 'आपकी स्वास्थ्य जानकारी लोड हो रही है…',
    yourAppointments: 'आपकी अपॉइंटमेंट',
    yourDetails: 'आपकी जानकारी',
    patientCode: 'मरीज़ कोड',
    mobile: 'मोबाइल',
    bloodGroup: 'ब्लड ग्रुप',
    allergies: 'एलर्जी',
    chronic: 'पुरानी बीमारी',
    medication: 'दवाइयाँ',
    doctors: 'डॉक्टर',
    visitHistory: 'विज़िट का इतिहास',
    noDiagnosis: 'कोई निदान दर्ज नहीं',
    visit: 'विज़िट',
    yourTurn: 'आज आपकी बारी',
    serial: 'क्रमांक',
    nowServing: 'अभी',
    aheadOfYou: 'आपसे पहले {n} लोग',
    youAreNext: 'अगली बारी आपकी है',
    beingSeen: 'डॉक्टर अभी आपको देख रहे हैं',
    seenDone: 'आपका परामर्श पूरा हो गया',
    refreshesItself: 'हर 30 सेकंड में अपने आप अपडेट होता है।',
    myAppointments: 'मेरी अपॉइंटमेंट',
    myLabTests: 'मेरे लैब टेस्ट',
    past: 'पिछली',
    cancelled: 'रद्द',
    cancel: 'रद्द करें',
    move: 'समय बदलें',
    keep: 'रहने दें',
    cancelTitle: 'यह बुकिंग रद्द करें?',
    cancelReason: 'कारण',
    cancelReasonPh: 'कोई काम आ गया…',
    changeWindow: 'बुकिंग में बदलाव समय से 2 घंटे पहले तक यहाँ कर सकते हैं। उसके बाद कृपया क्लिनिक को फ़ोन करें।',
    noLabTests: 'कोई लैब टेस्ट बुक नहीं',
    bookLabTest: 'लैब टेस्ट बुक करें',
    bookThisTest: 'यह टेस्ट बुक करें',
    shareTicket: 'टिकट भेजें',
    tApptConfirmed: 'अपॉइंटमेंट पक्की',
    tApptMoved: 'अपॉइंटमेंट का समय बदला',
    tLabBooked: 'लैब टेस्ट बुक',
    tBooking: 'बुकिंग',
    tPatient: 'मरीज़',
    tDoctor: 'डॉक्टर',
    tTest: 'टेस्ट',
    tDate: 'तारीख',
    tTime: 'समय',
    tWhen: 'कब',
    tPaid: 'भुगतान हो गया · रसीद {ref}',
    tPaidPlain: 'भुगतान हो गया',
    tFeeDue: 'फ़ीस: {amount} — क्लिनिक में दें',
    tNothingDue: 'फ़ीस: कुछ बाकी नहीं',
    tPreparation: 'तैयारी',
    tClinicPhone: 'क्लिनिक फ़ोन',
    tArrive: 'कृपया 10 मिनट पहले आएँ और यह टिकट साथ लाएँ।',
    tSerial: 'क्रमांक',
    tAmountPaid: 'राशि: {amount} — भुगतान हो गया',
    tAmountPaidReceipt: 'राशि: {amount} — भुगतान हो गया (रसीद {ref})',
    tAddress: 'पता',
    tLabArrive: 'कृपया अपने समय से 10 मिनट पहले आएँ और लैब काउंटर पर यह संदेश दिखाएँ।',
    tReceiptTitle: 'भुगतान रसीद',
    tReceiptNo: 'रसीद',
    tFee: 'फ़ीस',
    tDiscount: 'छूट',
    tPaidBy: 'भुगतान: {amount} ({mode})',
    tBalanceDue: 'बाकी: {amount}',
    tReference: 'संदर्भ',
    tKeepReceipt: 'धन्यवाद। इस संदेश को अपनी रसीद के रूप में रखें।',
  },
  mr: {
    hi: 'नमस्कार, {name}',
    goodMorning: 'सुप्रभात',
    goodAfternoon: 'शुभ दुपार',
    goodEvening: 'शुभ संध्याकाळ',
    visits: 'भेटी',
    lastSeen: 'मागील भेट',
    upcoming: 'पुढील',
    careEyebrow: 'गरज असेल तेव्हा काळजी',
    findDoctorTitle: 'पुढील भेटीसाठी डॉक्टर निवडा',
    findDoctorBody: 'विशेषता आणि उपलब्ध वेळा पाहा.',
    findDoctor: 'डॉक्टर शोधा',
    loadingSummary: 'तुमची आरोग्य माहिती लोड होत आहे…',
    yourAppointments: 'तुमच्या अपॉइंटमेंट',
    yourDetails: 'तुमची माहिती',
    patientCode: 'रुग्ण कोड',
    mobile: 'मोबाइल',
    bloodGroup: 'रक्तगट',
    allergies: 'ॲलर्जी',
    chronic: 'दीर्घ आजार',
    medication: 'औषधे',
    doctors: 'डॉक्टर',
    visitHistory: 'भेटींचा इतिहास',
    noDiagnosis: 'निदान नोंदवलेले नाही',
    visit: 'भेट',
    yourTurn: 'आज तुमचा नंबर',
    serial: 'क्रमांक',
    nowServing: 'सध्या',
    aheadOfYou: 'तुमच्या आधी {n} जण',
    youAreNext: 'पुढचा नंबर तुमचा',
    beingSeen: 'डॉक्टर आता तुम्हाला तपासत आहेत',
    seenDone: 'तुमची तपासणी पूर्ण झाली',
    refreshesItself: 'दर 30 सेकंदांनी आपोआप अपडेट होते.',
    myAppointments: 'माझ्या अपॉइंटमेंट',
    myLabTests: 'माझ्या लॅब तपासण्या',
    past: 'मागील',
    cancelled: 'रद्द',
    cancel: 'रद्द करा',
    move: 'वेळ बदला',
    keep: 'राहू द्या',
    cancelTitle: 'ही बुकिंग रद्द करायची?',
    cancelReason: 'कारण',
    cancelReasonPh: 'काम आले…',
    changeWindow: 'बुकिंग वेळेच्या 2 तास आधीपर्यंत इथे बदलता येते. त्यानंतर कृपया क्लिनिकला फोन करा.',
    noLabTests: 'कोणतीही लॅब तपासणी बुक नाही',
    bookLabTest: 'लॅब तपासणी बुक करा',
    bookThisTest: 'ही तपासणी बुक करा',
    shareTicket: 'तिकीट पाठवा',
    tApptConfirmed: 'अपॉइंटमेंट निश्चित',
    tApptMoved: 'अपॉइंटमेंटची वेळ बदलली',
    tLabBooked: 'लॅब तपासणी बुक',
    tBooking: 'बुकिंग',
    tPatient: 'रुग्ण',
    tDoctor: 'डॉक्टर',
    tTest: 'तपासणी',
    tDate: 'तारीख',
    tTime: 'वेळ',
    tWhen: 'केव्हा',
    tPaid: 'पैसे भरले · पावती {ref}',
    tPaidPlain: 'पैसे भरले',
    tFeeDue: 'फी: {amount} — क्लिनिकमध्ये भरा',
    tNothingDue: 'फी: काही बाकी नाही',
    tPreparation: 'तयारी',
    tClinicPhone: 'क्लिनिक फोन',
    tArrive: 'कृपया 10 मिनिटे आधी या आणि हे तिकीट सोबत आणा.',
    tSerial: 'क्रमांक',
    tAmountPaid: 'रक्कम: {amount} — भरली',
    tAmountPaidReceipt: 'रक्कम: {amount} — भरली (पावती {ref})',
    tAddress: 'पत्ता',
    tLabArrive: 'कृपया तुमच्या वेळेच्या 10 मिनिटे आधी या आणि लॅब काउंटरवर हा संदेश दाखवा.',
    tReceiptTitle: 'पेमेंट पावती',
    tReceiptNo: 'पावती',
    tFee: 'फी',
    tDiscount: 'सवलत',
    tPaidBy: 'भरले: {amount} ({mode})',
    tBalanceDue: 'बाकी: {amount}',
    tReference: 'संदर्भ',
    tKeepReceipt: 'धन्यवाद. हा संदेश तुमची पावती म्हणून जपून ठेवा.',
  },
  or: {
    hi: 'ନମସ୍କାର, {name}',
    goodMorning: 'ଶୁଭ ସକାଳ',
    goodAfternoon: 'ଶୁଭ ଅପରାହ୍ନ',
    goodEvening: 'ଶୁଭ ସନ୍ଧ୍ୟା',
    visits: 'ପରିଦର୍ଶନ',
    lastSeen: 'ଶେଷ ଥର',
    upcoming: 'ଆଗାମୀ',
    careEyebrow: 'ଦରକାର ବେଳେ ଯତ୍ନ',
    findDoctorTitle: 'ଆପଣଙ୍କ ପରବର୍ତ୍ତୀ ପରିଦର୍ଶନ ପାଇଁ ଡାକ୍ତର ବାଛନ୍ତୁ',
    findDoctorBody: 'ବିଶେଷଜ୍ଞତା ଓ ଉପଲବ୍ଧ ପରାମର୍ଶ ସମୟ ଦେଖନ୍ତୁ।',
    findDoctor: 'ଡାକ୍ତର ଖୋଜନ୍ତୁ',
    loadingSummary: 'ଆପଣଙ୍କ ସ୍ୱାସ୍ଥ୍ୟ ସୂଚନା ଲୋଡ୍ ହେଉଛି…',
    yourAppointments: 'ଆପଣଙ୍କ ଆପଏଣ୍ଟମେଣ୍ଟ',
    yourDetails: 'ଆପଣଙ୍କ ବିବରଣୀ',
    patientCode: 'ରୋଗୀ କୋଡ୍',
    mobile: 'ମୋବାଇଲ୍',
    bloodGroup: 'ରକ୍ତ ଗ୍ରୁପ୍',
    allergies: 'ଆଲର୍ଜି',
    chronic: 'ପୁରୁଣା ରୋଗ',
    medication: 'ଔଷଧ',
    doctors: 'ଡାକ୍ତର',
    visitHistory: 'ପରିଦର୍ଶନ ଇତିହାସ',
    noDiagnosis: 'କୌଣସି ନିଦାନ ଲେଖାଯାଇନାହିଁ',
    visit: 'ପରିଦର୍ଶନ',
    yourTurn: 'ଆଜି ଆପଣଙ୍କ ପାଳି',
    serial: 'କ୍ରମାଙ୍କ',
    nowServing: 'ବର୍ତ୍ତମାନ',
    aheadOfYou: 'ଆପଣଙ୍କ ଆଗରେ {n} ଜଣ',
    youAreNext: 'ପରବର୍ତ୍ତୀ ପାଳି ଆପଣଙ୍କର',
    beingSeen: 'ଡାକ୍ତର ବର୍ତ୍ତମାନ ଆପଣଙ୍କୁ ଦେଖୁଛନ୍ତି',
    seenDone: 'ଆପଣଙ୍କ ପରାମର୍ଶ ସମ୍ପୂର୍ଣ୍ଣ ହେଲା',
    refreshesItself: 'ପ୍ରତି 30 ସେକେଣ୍ଡରେ ନିଜେ ଅପଡେଟ୍ ହୁଏ।',
    myAppointments: 'ମୋ ଆପଏଣ୍ଟମେଣ୍ଟ',
    myLabTests: 'ମୋ ଲ୍ୟାବ୍ ପରୀକ୍ଷା',
    past: 'ପୂର୍ବ',
    cancelled: 'ବାତିଲ୍',
    cancel: 'ବାତିଲ୍ କରନ୍ତୁ',
    move: 'ସମୟ ବଦଳାନ୍ତୁ',
    keep: 'ରଖନ୍ତୁ',
    cancelTitle: 'ଏହି ବୁକିଂ ବାତିଲ୍ କରିବେ?',
    cancelReason: 'କାରଣ',
    cancelReasonPh: 'କିଛି କାମ ପଡ଼ିଗଲା…',
    changeWindow: 'ବୁକିଂ ସମୟର 2 ଘଣ୍ଟା ପୂର୍ବ ପର୍ଯ୍ୟନ୍ତ ଏଠାରେ ବଦଳାଇ ପାରିବେ। ତା’ପରେ ଦୟାକରି କ୍ଲିନିକ୍‌କୁ ଫୋନ୍ କରନ୍ତୁ।',
    noLabTests: 'କୌଣସି ଲ୍ୟାବ୍ ପରୀକ୍ଷା ବୁକ୍ ହୋଇନାହିଁ',
    bookLabTest: 'ଲ୍ୟାବ୍ ପରୀକ୍ଷା ବୁକ୍ କରନ୍ତୁ',
    bookThisTest: 'ଏହି ପରୀକ୍ଷା ବୁକ୍ କରନ୍ତୁ',
    shareTicket: 'ଟିକେଟ୍ ପଠାନ୍ତୁ',
    tApptConfirmed: 'ଆପଏଣ୍ଟମେଣ୍ଟ ନିଶ୍ଚିତ',
    tApptMoved: 'ଆପଏଣ୍ଟମେଣ୍ଟ ସମୟ ବଦଳିଲା',
    tLabBooked: 'ଲ୍ୟାବ୍ ପରୀକ୍ଷା ବୁକ୍ ହେଲା',
    tBooking: 'ବୁକିଂ',
    tPatient: 'ରୋଗୀ',
    tDoctor: 'ଡାକ୍ତର',
    tTest: 'ପରୀକ୍ଷା',
    tDate: 'ତାରିଖ',
    tTime: 'ସମୟ',
    tWhen: 'କେବେ',
    tPaid: 'ଦେୟ ଦିଆଗଲା · ରସିଦ {ref}',
    tPaidPlain: 'ଦେୟ ଦିଆଗଲା',
    tFeeDue: 'ଫି: {amount} — କ୍ଲିନିକ୍‌ରେ ଦିଅନ୍ତୁ',
    tNothingDue: 'ଫି: କିଛି ବାକି ନାହିଁ',
    tPreparation: 'ପ୍ରସ୍ତୁତି',
    tClinicPhone: 'କ୍ଲିନିକ୍ ଫୋନ୍',
    tArrive: 'ଦୟାକରି 10 ମିନିଟ୍ ପୂର୍ବରୁ ଆସନ୍ତୁ ଓ ଏହି ଟିକେଟ୍ ସାଙ୍ଗରେ ଆଣନ୍ତୁ।',
    tSerial: 'କ୍ରମାଙ୍କ',
    tAmountPaid: 'ରାଶି: {amount} — ଦେୟ ଦିଆଗଲା',
    tAmountPaidReceipt: 'ରାଶି: {amount} — ଦେୟ ଦିଆଗଲା (ରସିଦ {ref})',
    tAddress: 'ଠିକଣା',
    tLabArrive: 'ଦୟାକରି ଆପଣଙ୍କ ସମୟର 10 ମିନିଟ୍ ପୂର୍ବରୁ ଆସନ୍ତୁ ଓ ଲ୍ୟାବ୍ କାଉଣ୍ଟରରେ ଏହି ବାର୍ତ୍ତା ଦେଖାନ୍ତୁ।',
    tReceiptTitle: 'ଦେୟ ରସିଦ',
    tReceiptNo: 'ରସିଦ',
    tFee: 'ଫି',
    tDiscount: 'ରିହାତି',
    tPaidBy: 'ଦେୟ: {amount} ({mode})',
    tBalanceDue: 'ବାକି: {amount}',
    tReference: 'ସନ୍ଦର୍ଭ',
    tKeepReceipt: 'ଧନ୍ୟବାଦ। ଏହି ବାର୍ତ୍ତାକୁ ଆପଣଙ୍କ ରସିଦ ଭାବେ ରଖନ୍ତୁ।',
  },
})
